import { Routes } from "@angular/router";
import { EventsComponent } from "./MasterData/events/events.component";

export const MasterDatarouting: Routes = [
    {
        path: '',
        children: [
              { path: 'events-world', component:  EventsComponent}
        ],
        
    }
];